import React from 'react'

export default props => (
    <thead style={props.style}>
		{props.children}
	</thead>
)
